import { react2angular } from 'react2angular';

import ListingContactTable from './ListingContactTable';

angular
  .module('bb.listing_contacts', ['ngRoute', 'bb.util'])
  .component(
    'bbListingContactTable',
    react2angular(ListingContactTable, ['contacts', 'onSelect', 'selectedId']),
  );

require('./listing_contacts.service');

require('./listing_contacts.component');
